
if (document.querySelector('.post__stars-list .post__star')) {
  document.querySelectorAll('.post__stars-list .post__star').forEach((star) => {
    star.addEventListener('click', onStarClick);
  });
}

function onStarClick(event) {
  const postElement = event.target.closest('.post');
  const postId = postElement ? postElement.dataset.postId : null;

  if (!postId) {
    console.error('Post ID не найден');

    return;
  }

  // Проверяем, есть ли запись о данном посте в cookie
  const searchedCookie = document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`did_user_rated_${postId}=`));

  if (!searchedCookie) {
    // Обновляем рейтинг только если оценка еще не была сохранена для данного поста
    const ratingSpans = postElement.querySelectorAll('.post__rating');

    ratingSpans.forEach((span) => {
      const match = span.textContent.match(/(\d+\.\d+)\sиз\s5\s\((\d+)\)/);

      if (match) {
        let ratingValue = parseFloat(match[1]);
        let totalRatings = parseInt(match[2], 10);

        // Увеличиваем количество оценок на 1
        totalRatings += 1;
        span.textContent = `${ratingValue} из 5 (${totalRatings})`;

        // Устанавливаем cookie с датой истечения через 1 год
        const expirationDate = new Date();

        expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        document.cookie = `did_user_rated_${postId}=${totalRatings}; path=/; expires=${expirationDate.toUTCString()}`;
      }
    });
  }
}
